module.exports = __webpack_public_path__ + "img/ALoT2.28330ccc.webp";